<template>
    <div>
        <!-- <h1>{{ $t('betalingfejl')}}</h1> -->
        <h1>{{ $t('tilkoebmorgenmad') }}</h1>

        <div class="form">
            <div class="formColumn">
                <!-- Fakturanr -->
                <input type="text" v-model="login.invoiceno" name="invoiceno" :placeholder="$t('fakturanr')"          style="width: 250px; height: 15px; margin: 0px 0px 15px 0px;">
                <span v-if="loginDataError.invoiceno && submit==1" class="error">{{ $t('mangler')}} {{$t('fakturanr')}}</span>

                <!-- Dørkode -->
                <input type="text" v-model="login.doorcode" name="doorcode" :placeholder="$t('doorcode')"          style="width: 250px; height: 15px; margin: 0px 0px 15px 0px;">
                <span v-if="loginDataError.doorcode && submit==1" class="error">{{ $t('mangler')}} {{$t('doorcode')}}</span>
            </div>
        </div>


        <div class="buttonContainer">
            <router-link to=".">
                <div class="continueButton">
                    <a>&laquo; {{ $t('tilbage')}}</a>
                </div>
            </router-link>

            <!--
            <div class="continueButton" style="opacity: 0.2;">
                <a>{{ $t('findbooking') }} &raquo;</a>
            </div>
            -->
            <a>
                <div v-on:click="storeLoginData(login)" v-if="login.invoiceno && login.doorcode" class="continueButton">
                    <a>{{ $t('findbooking') }} &raquo;</a>
                </div>

                <div v-else v-on:click="checkLoginDataForErrors(login)" class="continueButton" style="opacity: 0.2;">
                    <a>{{ $t('findbooking') }} &raquo;</a>
                </div>
            </a>

        </div>





    </div>
</template>

<script>
import i18n from '@/plugins/i18n';

export default {
    data() {
        return {
            locale: i18n.locale,
            apiLoaded: 0,
            login: {'invoiceno': '', 'doorcode': ''},
            loginDataError: {'invoiceno': '', 'doorcode': ''},
            submit: 0
        };
    },
    created() {
    },
    methods: {
        storeLoginData(data) {
            this.submit=1; // Så vi kun viser fejl hvis der er forsøgt at trykke "videre"
            this.checkLoginDataForErrors(data);

            if (!this.loginDataError.invoiceno && !this.loginDataError.doorcode) {
                console.log('Alle data tilstede - gemmer data...');

                // Gem kundens indtastning i Vuex
                data.koncern = this.$route.params.koncern
                this.$store.dispatch("addAfterAddonData", data).then((login) => {
                    console.log('login forsøg: '+JSON.stringify(login));

                    // Send videre til tilkøbs siden
                    this.$router.push({ path: 'efterbestilling/2'});
                })

            }
        },
        checkLoginDataForErrors(data) {
            this.submit=0;

            if(!data.invoiceno || data.invoiceno.length < 2) {
                console.log("Invoiceno er ikke udfyldt...");
                this.loginDataError.invoiceno = 1;
            } else {
                this.loginDataError.invoiceno = 0;
            }

            if(!data.doorcode || data.doorcode.length < 2) {
                console.log("Doorcode er ikke udfyldt...");
                this.loginDataError.doorcode = 1;
            } else {
                this.loginDataError.doorcode = 0;
            }
        }
    }
}
</script>

<style scoped>

.flex-container {
  list-style: none;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  flex-direction:row;
  -ms-flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
}

.flex-item {
  padding: 10px;
  width: 85vw;
  max-width: 330px;
  height: 150px;
  margin-top: 10px;
  display: flex;
}

/* Giver de enkelte input-elementer styling, hvid border, transparent baggrund og padding */
.form input[type="text"], [type="checkbox"], textarea {
    background: transparent;
    border: 2px solid white;
    color: white;
    padding: 5px;
}

.form ::placeholder {
    color: rgba(255, 255, 255, 0.50);
}

/* Flex container, angiver hvordan den skal opføre sig ved smallere viewport */
.form {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    padding: 5px;
    max-width: 1024px;
    margin: 0 auto;
    
}
/* De enkelte kolonner i flexboxen */
.formColumn {
    flex: 0 0 30%;
    padding: 5px;
}

::placeholder {
    color: white;
    opacity: 1;
}

.error {
    color: red;
    font-weight: bold;
}

/* Customize the label (the container) */
.container {
  display: block;
  position: relative;
  padding-left: 50px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  text-align: left;
}

.buttonContainer {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin-bottom: 50px;
}

.continueButton {
  -webkit-border-radius: 0;
  -moz-border-radius: 0;
  border-radius: 0px;
  -webkit-box-shadow: 0px 4px 4px #666666;
  -moz-box-shadow: 0px 4px 4px #666666;
  box-shadow: 0px 10px 20px #666666;
  color: #000000;
  background-color: rgba(255,255,255,0.87);
  width: 280px;
  height: 80px;  
  font-size: 150%;
  letter-spacing: 1px;
  padding-left: 10px;
  padding-right: 10px;
  margin: 20px;
  white-space: nowrap;
  cursor: pointer;
}

a {
  text-decoration: none;
  color: black;
  text-align: center;
  line-height: 80px;
}
</style>